import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  styled,
  Box,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import "@react-pdf-viewer/core/lib/styles/index.css";
import * as pdfjsLib from "pdfjs-dist";
import { useNavigate } from "react-router-dom";
import { Add as AddIcon, Edit as EditIcon } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  useFetchReportVersionQuery,
  useFetchCommentsQuery,
  useUpdateCommentsMutation,
  useAddCommentsMutation,
} from "../../../services/user-reportService";

// Set the worker URL for PDF.js
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const UserReports = () => {
  const navigate = useNavigate();
  const { users } = useAuth();
  const employeeId = users?.user_id;
  // const [selectedPdfPath, setSelectedPdfPath] = useState(null);
  const [editingComment, setEditingComment] = useState(null);
  const [editedCommentText, setEditedCommentText] = useState("");
  const [newCommentText, setNewCommentText] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedReportVersionId, setSelectedReportVersionId] = useState(null);
  const [isAddCommentDialogOpen, setIsAddCommentDialogOpen] = useState(false);
  // const [openPDF, setOpenPDF] = useState(false);

  // Using Redux Toolkit query hooks
  const {
    data: reportVersions,
    isLoading: reportVersionsLoading,
    refetch: fetching_versions,
  } = useFetchReportVersionQuery(employeeId);
  const {
    data: comments,
    isLoading: commentsLoading,
    refetch: fetching_comments,
  } = useFetchCommentsQuery(employeeId);
 

  const [addComment] = useAddCommentsMutation();
  const [updateComment] = useUpdateCommentsMutation();
 
  // Handle PDF file path selection
  const handleViewPDF = (pdfurl) => {
    console.log(pdfurl)
    // window.open(`https://activate-pdfstorage.s3.ap-southeast-2.amazonaws.com/${pdfurl}`, "_blank");
    window.open(`${process.env.REACT_APP_AZURE_BLOB_BASE_URL || "https://activehrsaprod.blob.core.windows.net/activatehrpdf"}/${pdfurl}`, "_blank");
    
    window.open(pdfurl, "_blank");
   
    navigate('/user-reports');

  // Redirect back to a specific route (e.g., home)
    // if (newTab) {
    //   navigate('/user-reports');
    // }
  };
  useEffect(() => {
    fetching_versions()
    fetching_comments()
},[fetching_comments, fetching_versions]);
  
  const handleAddCommentClick = (userId, reportVersionId) => {
    setSelectedUserId(userId);
    setSelectedReportVersionId(reportVersionId);
    setIsAddCommentDialogOpen(true);
  };

  const handleSubmitNewComment = async () => {
    
    try {
      const result = await addComment({
        comment_text: newCommentText,
        user_id: selectedUserId,
        report_version_id: selectedReportVersionId,
      });
      console.log("API response:", result);
      setIsAddCommentDialogOpen(false);
      setNewCommentText("");
      fetching_comments();
      // Clear the input field
    } catch (err) {
      console.error("Failed to add comment:", err);
    }
  };

  const handleEditClick = (
    commentId,
    commentText,
    selectedUserId,
    reportVersionId
  ) => {
    // console.log(selectedUserId);
    // console.log(reportVersionId);

    setEditingComment(commentId);
    setEditedCommentText(commentText);
    setSelectedUserId(selectedUserId);
    setSelectedReportVersionId(reportVersionId);
  };

  const handleSaveEdit = async () => {
    console.log(selectedReportVersionId);

    try {
      await updateComment({
        comment_text: editedCommentText,
        user_id: employeeId,
        report_version_id: editingComment,
      }).unwrap();
      setEditingComment(null); // Exit edit mode
      setEditedCommentText("");
      fetching_comments(); // Clear the input field
    } catch (err) {
      console.error("Failed to update comment:", err);
      // Optionally, show a user-friendly error message
    }
  };

  // Check if the data is still loading
  if (reportVersionsLoading || commentsLoading) {
    return <CircularProgress />;
  }
  const reportVersionsArray = Array.isArray(reportVersions?.data)
    ? reportVersions.data
    : [];
  const commentsArray = Array.isArray(comments?.data) ? comments.data : [];

  // console.log("Report Versions:", reportVersions);
  // console.log("Comments:", comments);

  // Function to map comments to the corresponding report version
  const mapCommentsToVersion = (versionId) => {
    if (!Array.isArray(commentsArray)) return [];
    return commentsArray.filter(
      (comment) => comment.report_version_id === versionId
    );
  };

  const columns = [
    {
      field: "version_number",
      headerName: "Version Number",
      // width: 200, 
      
      flex: 1,
    },
    {
      field: "generated_at",
      headerName: "Generated At",
      flex: 1,
      renderCell: (params) => {
        const date = new Date(params.row.generated_at);
        return date.toLocaleString();
      },
    },
    {
      field: "comment_text",
      headerName: "Comments",
      flex: 1,
      // minWidth: 200, // Ensure a minimum width
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        const versionId = params.row.id;
        const versionComments = mapCommentsToVersion(versionId);
        return (
          <Box>
            {versionComments.length > 0 ? (
              versionComments.map((comment) => (
                <Box key={comment.id} sx={{ position: "relative" }}>
                  {comment.comment_text}
                  <CustomBtn3
                  
                    onClick={() =>
                      handleEditClick(
                        comment.id,
                        comment.comment_text,
                        employeeId,
                        versionId
                      )
                    }
                  >
                    <EditIcon fontSize="inherit" />
                  </CustomBtn3>
                </Box>
              ))
            ) : (
              <Box key={versionComments.id} sx={{ position: "relative" }}>
                No comments available
                <CustomBtn3
                  onClick={() => handleAddCommentClick(employeeId, versionId)}
                >
                  <AddIcon fontSize="inherit" />
                </CustomBtn3>
              </Box>
            )}
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <CustomBtn2
              sx={{ background: "#1085AB", borderColor: "#1085AB" }}
              onClick={() => handleViewPDF(params.row.pdf_path)}
            >
              <VisibilityIcon fontSize="inherit" />
            </CustomBtn2>
            <CustomBtn2 onClick={() => navigate("/user_details-steps")}>
              <EditIcon fontSize="inherit" />
            </CustomBtn2>
          </>
        );
      },
    },
  ];
  return (
    <>
      <SectionWrap component="section">
        <ContainerWrap>
          <RowWrap>
            <Col12Wrap>
              <DashboardBoxWrap>
                <DataGrid
                  rows={reportVersionsArray}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 30,
                      },
                    },
                  }}
                  pageSizeOptions={[30]}
                  disableRowSelectionOnClick
                  disableColumnMenu={true}
                  style={{
                    minWidth: "600px", // Set a minimum width for horizontal scrolling
                  }}
                />
              </DashboardBoxWrap>
            </Col12Wrap>
          </RowWrap>
        </ContainerWrap>
      </SectionWrap>

      {/* Edit Comment Dialog */}
      <Dialog
        open={editingComment !== null}
        onClose={() => setEditingComment(null)}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            padding: "30px",
          },
        }}
      >
        <DialogTitleWrap>Edit Comment</DialogTitleWrap>
        <DialogContentWrap>
          <TextField
            fullWidth
            placeholder="Comment"
            multiline
            rows={4}
            value={editedCommentText}
            onChange={(e) => setEditedCommentText(e.target.value)}
            
            sx={{
              
              width: "100%",
              border: "1px solid #DADADA",
              borderRadius: "7px",
              "& .MuiInputBase-formControl": {
                padding: "0",
              },
              "& .MuiInputBase-input": {
                fontSize: "16px",
                fontWeight: "300",
                lineHeight: "1",
                color: "#2C2C2E",
                padding: "14px 20px",
              },
              "& fieldset": {
                border: "none",
              },
            }}
          />
        </DialogContentWrap>
        <DialogActionsWrap>
          <CustomCancelBtn onClick={() => setEditingComment(null)}>
            Cancel
          </CustomCancelBtn>
          <CustomBtn onClick={handleSaveEdit}>Save</CustomBtn>
        </DialogActionsWrap>
      </Dialog>
      {/* Add Comment Dialog */}
      <Dialog
        open={isAddCommentDialogOpen}
        onClose={() => setIsAddCommentDialogOpen(false)}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            padding: "30px",
          },
        }}
      >
        <DialogTitleWrap>Add Comment</DialogTitleWrap>
        <DialogContentWrap>
          <TextField
            fullWidth
            placeholder="Comment"
            multiline
            rows={4}
            value={newCommentText}
            onChange={(e) => setNewCommentText(e.target.value)}
            sx={{
              width: "100%",
              border: "1px solid #DADADA",
              borderRadius: "7px",
              "& .MuiInputBase-formControl": {
                padding: "0",
              },
              "& .MuiInputBase-input": {
                fontSize: "16px",
                fontWeight: "300",
                lineHeight: "1",
                color: "#2C2C2E",
                padding: "14px 20px",
              },
              "& fieldset": {
                border: "none",
              },
            }}
          />
        </DialogContentWrap>
        <DialogActionsWrap>
          <CustomCancelBtn onClick={() => setIsAddCommentDialogOpen(false)}>
            Cancel
          </CustomCancelBtn>
          <CustomBtn onClick={handleSubmitNewComment}>Save</CustomBtn>
        </DialogActionsWrap>
      </Dialog>
    </>
  );
};

export default UserReports;
const SectionWrap = styled(Box)(() => ({
  padding: "30px 0",
  "@media (max-width: 768px)": {
    padding: "15px 0", // Adjust padding for mobile
  },
}));

const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
  "@media (max-width: 768px)": {
    paddingLeft: "10px",
    paddingRight: "10px",
  },
}));


const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));


const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 768px)": {
    paddingLeft: "10px",
    paddingRight: "10px",
  },
}));


const DashboardBoxWrap = styled(Box)(() => ({
  padding: "15px",
  background: "#ffffff",
  borderRadius: "7px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 991px)": {
    padding: "30px 30px",
  },
  "@media (max-width: 669px)": {
    padding: "10px", // Adjust padding for small screens
    overflowX: "auto", // Enable horizontal scrolling
    whiteSpace: "nowrap", // Prevent content wrapping for horizontal scroll
  },
  overflowX: "auto", // Allow horizontal scrolling
  overflowY: "auto", // Allow vertical scrolling
  whiteSpace: "nowrap",// Ensure content doesn't overflow the screen
}));


const DialogTitleWrap = styled(DialogTitle)(() => ({
  fontSize: "20px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "15px",
  padding: "0",
}));


const DialogContentWrap = styled(DialogContent)(() => ({
  marginBottom: "15px",
  padding: "0",
  maxHeight: "calc(100vh - 200px)", // Ensure dialog content scrolls on mobile
  overflowY: "auto", 
  overflowX: "auto", 
  // Vertical scrolling inside the dialog
}));


const DialogActionsWrap = styled(DialogActions)(() => ({
  padding: "0",
}));

const CustomBtn = styled(Button)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#1085AB",
  borderColor: "#1085AB",
  borderRadius: "10px",
  padding: "13px 20px",
  boxShadow: "none !important",
}));

const CustomCancelBtn = styled(Button)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#d32f2f",
  borderColor: "#d32f2f",
  borderRadius: "10px",
  padding: "13px 20px",
  boxShadow: "none !important",
}));

const CustomBtn2 = styled(Button)(() => ({
  minWidth: "auto",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "5px",
  padding: "10px",
  margin: "0 5px",
  boxShadow: "none !important",
}));

const CustomBtn3 = styled(Button)(() => ({
  position: 'absolute',
  top: '50%',
  right: '0',
  transform: 'translateY(-50%)',
  minWidth: "auto",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "5px",
  padding: "5px",
  margin: "0 5px",
  boxShadow: "none !important",
  '@media (max-width: 768px)': {
    right: '10px', // Move the icon slightly inward on smaller screens
    top: '50%',
    transform: 'translateY(-50%)',
  },
}));



